var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"stroke":"#FFF"},React.createElement("g",null,[React.createElement("path",{"d":"M46.992 23.747c0 12.837-10.407 23.245-23.246 23.245C10.907 46.992.5 36.585.5 23.747.5 10.907 10.907.5 23.746.5c12.84 0 23.246 10.408 23.246 23.247zM23.746.5L23.746 5.022M46.948 23.703L42.426 23.703M5.066 23.703L.544 23.703M23.746 46.905L23.746 42.383M40.226 7.295L37.029 10.493M40.226 40.109L37.029 36.911M10.61 10.494L7.413 7.296M7.413 40.109L10.61 36.911","transform":"translate(-178 -1325) translate(178 1325)","key":0}),React.createElement("path",{"d":"M23.746 9.443L23.746 24.124 33.638 24.124","transform":"translate(-178 -1325) translate(178 1325)","key":1})]))));
}

Clock.defaultProps = {"width":"47","height":"47","viewBox":"0 0 47 47"};

module.exports = Clock;

Clock.default = Clock;
